import React, { Component } from 'react'

import { Row, Col, Container } from 'components/Layout'
import Page from 'components/Page'
import PageHeader from 'components/Page/PageHeader'
import { Crumbs } from 'components/BreadCrumbs'
import InfoCard from 'components/Cards/InfoCard'
import LinedTable from 'components/Tables/LinedTable'
import Button from 'components/Button'
import ServiceStatusGraph from 'features/Graphs/ServiceStatusGraph'
import { CallsVolumeAllServicesContainer } from 'features/CallAnalytics/Cards/CallsVolumeAllServices'
import { moment } from 'features/Moment'
import { Link } from 'react-router'

import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import sMarg from 'styles/modules/margins.scss'
import sAnim from 'components/Animation/Animation.scss'

const currentDate = moment()

export default class Dashboard extends Component {
  componentWillMount() {
    const { getNumbers, getBills, getCases, getOutages } = this.props
    getNumbers()
    getBills({ limit: 1000 })
    getCases()
    getOutages()
  }
  render() {
    const { services, bills, billsLoading, billingAccounts, cases, getCasesLoading } = this.props

    const expiringCreditCards =
      billingAccounts &&
      billingAccounts.reduce((result, billingAccount) => {
        if (billingAccount.directDebitMethod === 'Credit Card' && billingAccount.creditCardExpire) {
          const expireDate = moment(`01/${billingAccount.creditCardExpire}`, 'DD/MM/YYYY')
          const diff = moment.duration(expireDate.diff(currentDate))
          const hasExpired = diff < 0
          const expiringSoon = diff < 3

          if (hasExpired || expiringSoon) {
            result.push({
              status: hasExpired ? 'Expired' : 'Expiring soon',
              billingAccount,
            })
          }
        }

        return result
      }, [])

    const overdueBillingAccounts =
      billingAccounts &&
      billingAccounts.reduce((result, billingAccount) => {
        if (billingAccount.overdue > 0) {
          result.push({
            billingAccount,
          })
        }

        return result
      }, [])

    return (
      <Page layout={{ header: 'app' }} title="Dashboard">
        <PageHeader>
          <Crumbs title="Dashboard" />
        </PageHeader>
        <Container paddingTop paddingBottom className={cn('lg', sAnim.comeUp)}>
          <CallsVolumeAllServicesContainer />
          <Row className={cn(sLay['layout-gt-xs-row'], sLay['layout-xs-column'])}>
            <Col className={sLay['flex-gt-xs']}>
              <InfoCard
                to="/dashboard/numbers"
                toText="More"
                className={sMarg.mb30}
                title="Number Services"
              >
                <LinedTable>
                  {services.slice(0, 4).map(item => (
                    <div key={item.id}>
                      <div>{item.number}</div>
                      <div>{item.billingStatus}</div>
                    </div>
                  ))}
                </LinedTable>
              </InfoCard>
            </Col>
            <Col className={sLay['flex-gt-xs']}>
              <InfoCard
                to="/dashboard/billing"
                toText="More"
                className={sMarg.mb30}
                title="Recent Bills"
                loading={billsLoading && bills.length === 0}
              >
                <LinedTable>
                  {bills.slice(0, 4).map(item => (
                    <div key={item.id}>
                      <div>{item.date}</div>
                      <div>
                        <Button size="xs" color="tertiary" disabled={item.status === 'PAID'}>
                          {item.status === 'PAID' ? 'Paid' : 'Unpaid'}
                        </Button>
                      </div>
                    </div>
                  ))}
                  {bills.length === 0 && <div>You have no bills.</div>}
                </LinedTable>
              </InfoCard>
              <InfoCard
                to="/dashboard/cases"
                toText="More"
                className={sMarg.mb30}
                title="Support Cases"
                loading={getCasesLoading && cases.length === 0}
              >
                <LinedTable>
                  {cases.slice(0, 4).map(item => (
                    <div key={item.id}>
                      <div>{item.recordType}</div>
                      <div>{item.status}</div>
                    </div>
                  ))}
                  {cases.length === 0 && <div>No open support cases.</div>}
                </LinedTable>
              </InfoCard>
            </Col>
            <Col className={sLay['flex-gt-xs']}>
              {(expiringCreditCards.length > 0 || overdueBillingAccounts.length > 0) && (
                <InfoCard className={sMarg.mb30} title="Account Issues" color="red">
                  <LinedTable>
                    {/* Expiring Credit Cards */}
                    {expiringCreditCards.map(item => (
                      <div key={`expcc${item.billingAccount.ban}`}>
                        <div>
                          <Link to={`/dashboard/billing/accounts/${item.billingAccount.ban}`}>
                            Credit Card: {item.billingAccount.creditCardLast4Digits}
                          </Link>
                        </div>
                        <div>{item.status}</div>
                      </div>
                    ))}
                    {/* Overdue Billing Accounts */}
                    {overdueBillingAccounts.map(item => (
                      <div key={`ovrba${item.billingAccount.ban}`}>
                        <div>
                          <Link to={`/dashboard/billing?ban=${item.billingAccount.ban}`}>
                            {item.billingAccount.ban}
                          </Link>
                        </div>
                        <div>{`$${item.billingAccount.overdue} Overdue`}</div>
                      </div>
                    ))}
                  </LinedTable>
                </InfoCard>
              )}
              <InfoCard className={sMarg.mb30} title="Pickle Network Status">
                <ServiceStatusGraph />
              </InfoCard>
            </Col>
          </Row>
        </Container>
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Dashboard/Dashboard.jsx